import { useState } from 'react'
import ReactPlayer from 'react-player'
import Title from '../components/ui/Title'
import Button from '../components/ui/Button'
import ReactGA from 'react-ga4'
import { Link } from 'react-router-dom'
import '../styles/pages/media.scss'

const Gallery = () => {
    const [section, setSection] = useState('trailers')

    return (
        <div className='page-container' style={{ paddingBottom: '50px' }}>
            <Title text='gallery' />
            <div className='button-list'>
                <Link to={`/gallery`}>
                    <Button
                        type='solid'
                        text='Trailers'
                        color={`media ${section === 'trailers' && 'media-nav_active'}`}
                    />
                </Link>
                <Link to={`/gallery/wallpapers`}>
                    <Button
                        type='solid'
                        text='Wallpapers'
                        color={`media ${section === 'wallpapers' && 'media-nav_active'}`}
                    />
                </Link>
            </div>
            {/* <div className='main-container'>
                <div className='outline'>
                    <div className='trailer-title'>ANNOUNCEMENT TRAILER (Nintendo Switch 2 and PS5)</div>
                    <div className='video-container'>
                        <div className='video-wrapper'>
                            <ReactPlayer url='https://www.youtube.com/watch?v=8dssaQuEAiY' />
                        </div>
                    </div>
                </div>
            </div>{' '} */}
            <div className='main-container'>
                <div className='outline'>
                    <div className='trailer-title'>Release Date Announcement Trailer (Nintendo Switch 2 and PS5)</div>
                    <div className='video-container'>
                        <div className='video-wrapper'>
                            <ReactPlayer url='https://www.youtube.com/watch?v=XHpTVUikuO0' />
                        </div>
                    </div>
                </div>
            </div>{' '}   <div className='trailer-title'>ANNOUNCEMENT TRAILER (Nintendo Switch 2 and PS5)</div>
            <div className='video-container'>
                <div className='video-wrapper'>
                <ReactPlayer url='https://www.youtube.com/watch?v=8dssaQuEAiY' />
                </div>
            </div>
            <div className='trailer-title'>Story Trailer</div>
            <div className='video-container'>
                <div className='video-wrapper'>
                    <ReactPlayer url='https://www.youtube.com/watch?v=IjPAQQLf8PY' />
                </div>
            </div>
            <div className='trailer-title'>Character Trailer</div>
            <div className='video-container'>
                <div className='video-wrapper'>
                    <ReactPlayer url='https://www.youtube.com/watch?v=tcH5RXuZeh4' />
                </div>
            </div>
            <div className='trailer-title'>Teaser Trailer</div>
            <div className='video-container'>
                <div className='video-wrapper'>
                    <ReactPlayer url='https://www.youtube.com/watch?v=UeLWq9OYI2Q' />
                </div>
            </div>
        </div>
    )
}

export default Gallery
